import { render, staticRenderFns } from "./SelectStudentLevelsDialog.vue?vue&type=template&id=2bf73ca8&scoped=true&"
import script from "./SelectStudentLevelsDialog.ts?vue&type=script&lang=ts&"
export * from "./SelectStudentLevelsDialog.ts?vue&type=script&lang=ts&"
import style0 from "./SelectStudentLevelsDialog.scss?vue&type=style&index=0&id=2bf73ca8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf73ca8",
  null
  
)

export default component.exports